import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import AceEditor from 'react-ace';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CustomLoader from '../common/CustomLoader';
import ParentContentCard from '../common/ParentContentCard';
import { getBuilderURL } from '../../common/utils/builder-url-util';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class PageJsUpdate extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    isEditing: false,
    editorValue: '',
    activeTab: 'js-update-page',
    isFullScreen: false,
  };

  async componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version, pageId } = match.params;
    await actions.loadPageDetails({ projectId, version, pageId });
    await actions.loadProjectDetailAppSetting({ projectId, version });
    const { pageDetails } = this.props.appSetting;
    this.setState({ editorValue: pageDetails ? pageDetails.customScript : '' });
  }

  toggleFullscreen = () => {
    this.setState((prevState) => ({
      isFullScreen: !prevState.isFullScreen,
    }));
  };

  handleUpdate = async () => {
    const { match, appSetting, actions } = this.props;
    const { projectId, pageId, version } = match.params;
    const { pageDetails } = appSetting;
    const customScript = this.state.isEditing ? this.state.editorValue : pageDetails.customScript;
    await actions.updatePageScript({ projectId, version, pageId, customScript });
  };

  handleStartEditing = () => {
    const { pageDetails } = this.props.appSetting;
    this.setState({ isEditing: true, editorValue: pageDetails ? pageDetails.customScript : '' });
  };

  handleChange = (value) => {
    if (this.state.isEditing) {
      this.setState({ editorValue: value });
    }
  };

  appSettingToggle = (activeTab) => {
    const { history, match } = this.props;
    const { projectId, version } = match.params;
    history.push(`/app-setting/${version}/v/${projectId}/setting/${activeTab}`);
  };

  aiModelToggle = (activeTab) => {
    const { history, match } = this.props;
    const { projectId, version } = match.params;
    history.push(`/app-setting/${version}/v/${projectId}/setting/${activeTab}`);
  };

  handleCancel = () => {
    const { match } = this.props;
    const { projectId, pageId, version } = match.params;
    const redirectUrl = getBuilderURL();
    let token = getCookie('token');
    const url = `${redirectUrl}editor/${version}/v/${projectId}/pages/${pageId}?token=${token}`;
    window.location.href = url;
  };

  render() {
    const { appSetting } = this.props;
    const { pageDetails, updatePageScriptPending, projectDetail } = appSetting;
    let value;
    if (pageDetails) {
      value = this.state.isEditing ? this.state.editorValue : pageDetails.customScript;
    }
    const { uuid: projectId } = projectDetail;
    const isReadOnly = isProjectReadOnly(projectId);

    return (
      <CommonPageComponent>
        <AppSettingsNav
          activeTab={this.state.activeTab}
          projectDetail={projectDetail}
          advanceAppConstantToogle={this.appSettingToggle}
          CustomCSSJSMenuToogle={this.appSettingToggle}
          SnapshotMenuToogle={this.appSettingToggle}
          AIModelMenuToggle={this.aiModelToggle}
        />
        {pageDetails && (
          <ParentContentCard
            title={pageDetails.name}
            bgColor="drapcode-violet"
            icon="pages"
            CtaComponent={
              <button
                type="button"
                style={{ background: 'transparent', border: 'none' }}
                onClick={this.toggleFullscreen}
                title="Toggle Fullscreen"
              >
                <i
                  className={`btn btn-outline-primary btn-xs btn-icon-only ${drapcodeIcon(
                    'fullscreen',
                  )}`}
                  style={{ lineHeight: 1 }}
                ></i>
              </button>
            }
            fullscreen={this.state.isFullScreen}
          >
            <div className="d-flex justify-content-end"></div>
            <AceEditor
              mode="javascript"
              theme="github"
              value={value}
              name="code-editor1"
              width="100%"
              height={this.state.isFullScreen ? '77.5vh' : '60vh'}
              fontSize={15}
              wrapEnabled={true}
              showPrintMargin={false}
              readOnly={!this.state.isEditing}
              onChange={this.handleChange}
              onFocus={this.handleStartEditing}
            />
            <div className="d-flex justify-content-between align-items-center">
              <button
                className="btn btn-outline-secondary btn-md"
                title="Back to Builder"
                onClick={this.handleCancel}
              >
                <i className="wb webconnect-times"></i> Back To Builder
              </button>
              <button
                className="btn btn-theme-submit btn-md"
                title={isReadOnly ? 'Read-Only Mode' : 'Update'}
                onClick={isReadOnly ? undefined : this.handleUpdate}
                disabled={updatePageScriptPending || isReadOnly}
              >
                <i className="wb webconnect-save-regular"></i> Update
                {<CustomLoader loading={updatePageScriptPending} />}
              </button>
            </div>
          </ParentContentCard>
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageJsUpdate);
